import { defineMessages } from "react-intl";

export const messages = defineMessages({
  searchbarPlaceholder: {
    id: "portalCustomer.searchbar.placeholder",
    defaultMessage: "Name",
    description: "place holder for searchbar",
  },
});
